import React from "react";
import "./ColorInput.css"; 

export default function ColorCountInput({ colorCount, setColorCount }) {
  const incrementCount = () => setColorCount((prev) => prev + 1);
  const decrementCount = () => setColorCount((prev) => (prev > 1 ? prev - 1 : 1));

  const handleChange = (e) => {
    const value = parseInt(e.target.value, 10) || 1; 
    setColorCount(value < 1 ? 1 : value); 
  };

  return (
    <div className="color-count-container">
      <label htmlFor="colorCount" className="input-label">
        Number of Colors
      </label>
      <div className="color-count-input">
        <button 
          type="button" 
          className="color-button minus" 
          onClick={decrementCount}
        >
          -
        </button>
        <input
          id="colorCount"
          type="number"
          min="1"
          value={colorCount}
          onChange={handleChange}
        />
        <button 
          type="button" 
          className="color-button plus" 
          onClick={incrementCount}
        >
          +
        </button>
      </div>
    </div>
  );
}
